import React from "react";
import { Target, Lightbulb, ShieldCheck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const steps = [{
  number: "01",
  title: "Stratégie",
  description: "Nous commençons par une analyse approfondie de vos besoins et de votre environnement. Notre approche stratégique vise à définir une vision claire et des objectifs mesurables pour garantir un impact durable.",
  icon: Target
}, {
  number: "02",
  title: "Créativité",
  description: "L'innovation est au cœur de notre démarche. Nous concevons des identités visuelles et des concepts événementiels uniques qui captivent votre audience et renforcent votre image de marque.",
  icon: Lightbulb
}, {
  number: "03",
  title: "Rigueur",
  description: "L'excellence opérationnelle est notre signature. Une gestion de projet méticuleuse et un respect absolu des délais assurent une exécution sans faille, pour des résultats à la hauteur de vos exigences.",
  icon: ShieldCheck
}];
export default function MethodologicalApproach() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="methodological-approach" className="bg-background py-20 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16 lg:mb-24">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-foreground mb-6">
            Notre Approche Méthodologique
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Une méthodologie éprouvée qui allie réflexion stratégique, audace créative et précision opérationnelle pour transformer vos ambitions en succès concrets.
          </p>
        </div>

        <div ref={ref} className={cn("grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {steps.map((step, i) => <div key={step.number} data-index={i} className="h-full">
              <Card className="group relative h-full overflow-hidden border border-white/10 bg-primary/90 backdrop-blur-xl transition-all duration-500 hover:-translate-y-2 hover:border-secondary/50">
                {}
                <div className="absolute -right-4 -top-8 select-none font-serif text-[10rem] font-bold leading-none text-white/5 transition-transform duration-700 group-hover:scale-110 group-hover:text-white/10">
                  {step.number}
                </div>

                <CardHeader className="relative z-10 pb-2">
                  <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-white/10 text-secondary transition-transform duration-500 group-hover:scale-110">
                    <step.icon className="h-8 w-8 group-hover:animate-pulse" />
                  </div>
                  <CardTitle className="font-serif text-2xl font-bold text-white">
                    {step.title}
                  </CardTitle>
                </CardHeader>

                <CardContent className="relative z-10">
                  <CardDescription className="text-left text-base leading-tight text-white/80">
                    {step.description}
                  </CardDescription>
                </CardContent>

                {}
                <div className="absolute bottom-0 left-0 h-1 w-0 bg-secondary transition-all duration-500 group-hover:w-full" />
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}